/* tslint:disable */
// TSLint ломает этот файл
import { Component, ElementRef, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectAutocompleteWidget as GeoSelectAutocomplete } from '@geoanalitika/widgets';
import { Service } from '../../classes';

@Component({
  selector: 'geo-layers-autocomplete',
  templateUrl: 'layers-autocomplete.component.html',
  styleUrls: ['./layers-autocomplete.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LayersAutocompleteComponent),
      multi: true
    }
  ]
})
export class LayersAutocompleteComponent extends GeoSelectAutocomplete<Service> implements ControlValueAccessor {
  @Input()
  set items(data: Service[]) {
    this.originalItems = data;
    this.setItemsVal();
    this.filterItems(null);
  }

  get items(): Service[] {
    return this._items;
  }

  placeholder: string = 'Введите название сервиса или выберите из списка';

  constructor(el: ElementRef) {
    super(el);
  }
}
